import { Box } from '@mui/material';
import React from 'react';
import { AuthData } from '../../../context/auth';
import {
	EndorsementData,
	withEndorsementContext,
} from '../../../context/EndorsementProvider';
import { ErrorData } from '../../../context/ErrorProvider';
import { HEADER_HEIGHT } from '../../../data/constants';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../../common';
import FutureInvoicesTable from '../../FutureInvoicesTable';
import NewInvoicesTable from '../../NewInvoicesTable';

interface Props {
	authData: AuthData;
	endorsementData: EndorsementData;
	errorData: ErrorData;
}

const InvoicesView = (props: Props) => {
	const { endorsementData } = props;

	const { endorsementUpdateObj, policy } = endorsementData;

	const invoices = endorsementUpdateObj.invoice
		? [endorsementUpdateObj.invoice]
		: [];

	if (!endorsementUpdateObj.invoice && endorsementUpdateObj.plannedInvoices) {
		return (
			<>
				<StyledTitleContainer>
					<StyledTitle>Planned Invoices</StyledTitle>
				</StyledTitleContainer>
				<hr />
				<StyledSectionContainer>
					<FutureInvoicesTable
						invoices={endorsementUpdateObj.plannedInvoices}
						currency={policy?.currency}
					/>
				</StyledSectionContainer>
			</>
		);
	}

	return (
		<Box
			sx={{
				pt: 4,
				pb: 4,
				backgroundColor: 'background.default',
				height: `calc(100vh - ${HEADER_HEIGHT}px)`,
			}}
		>
			<NewInvoicesTable
				invoices={invoices}
				policyholderLocator={policy.policyholderLocator}
				currency={policy.currency}
			/>
		</Box>
	);
};

export default withEndorsementContext<Props>(InvoicesView);
